import { getBrands, getModels, getYears, getVersions } from '../services/car';
import { getToken } from '../services/galeno';

// constants
const initialState = {
  fetching: false,
  error: '',
  token: '',
  brands: [],
  models: [],
  years: [],
  versions: []
};

export const FETCH_TOKEN_PENDING = 'FETCH_TOKEN_PENDING';
export const FETCH_TOKEN_SUCCESS = 'FETCH_TOKEN_SUCCESS';
export const FETCH_TOKEN_FAILURE = 'FETCH_TOKEN_FAILURE';

export const FETCH_BRANDS_SUCCESS = 'FETCH_BRANDS_SUCCESS';
export const FETCH_BRANDS_PENDING = 'FETCH_BRANDS_PENDING';
export const FETCH_BRANDS_FAILURE = 'FETCH_BRANDS_FAILURE';

export const FETCH_MODELS_SUCCESS = 'FETCH_MODELS_SUCCESS';
export const FETCH_MODELS_PENDING = 'FETCH_MODELS_PENDING';
export const FETCH_MODELS_FAILURE = 'FETCH_MODELS_FAILURE';

export const FETCH_YEARS_SUCCESS = 'FETCH_YEARS_SUCCESS';
export const FETCH_YEARS_PENDING = 'FETCH_YEARS_PENDING';
export const FETCH_YEARS_FAILURE = 'FETCH_YEARS_FAILURE';

export const FETCH_VERSIONS_SUCCESS = 'FETCH_VERSIONS_SUCCESS';
export const FETCH_VERSIONS_PENDING = 'FETCH_VERSIONS_PENDING';
export const FETCH_VERSIONS_FAILURE = 'FETCH_VERSIONS_FAILURE';

// actions
export const fetchToken = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_TOKEN_PENDING });
      const token = await getToken();
      dispatch({ type: FETCH_TOKEN_SUCCESS, payload: token });
      localStorage.setItem('token', token);
    } catch (err) {
      dispatch({ type: FETCH_TOKEN_FAILURE, payload: err });
    }
  };
};

export const fetchBrands = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_BRANDS_PENDING });
      const brands = getBrands();
      dispatch({ type: FETCH_BRANDS_SUCCESS, payload: brands });
    } catch (err) {
      dispatch({ type: FETCH_BRANDS_FAILURE, payload: err });
    }
  };
};

export const fetchModels = (brandID) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_MODELS_PENDING });
      const models = await getModels(brandID);
      dispatch({ type: FETCH_MODELS_SUCCESS, payload: models });
    } catch (err) {
      dispatch({ type: FETCH_MODELS_FAILURE, payload: err });
    }
  };
};

export const fetchYears = (brandID, model) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_YEARS_PENDING });
      const years = await getYears(brandID, model);
      dispatch({ type: FETCH_YEARS_SUCCESS, payload: years });
    } catch (err) {
      dispatch({ type: FETCH_YEARS_FAILURE, payload: err });
    }
  };
};

export const fetchVersions = (brandID, model, year) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_VERSIONS_PENDING });
      const versions = await getVersions(brandID, model, year);
      dispatch({ type: FETCH_VERSIONS_SUCCESS, payload: versions });
    } catch (err) {
      dispatch({ type: FETCH_VERSIONS_FAILURE, payload: err });
    }
  };
};

// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOKEN_PENDING:
      return {
        ...state,
        fetching: true
      };
    case FETCH_TOKEN_SUCCESS:
      return {
        ...state,
        fetching: false,
        token: action.payload,
        error: ''
      };
    case FETCH_TOKEN_FAILURE:
      return {
        ...state,
        fetching: false,
        token: '',
        error: action.payload
      };
    case FETCH_BRANDS_PENDING:
      return {
        ...state,
        fetching: true
      };
    case FETCH_BRANDS_SUCCESS:
      return {
        ...state,
        fetching: false,
        brands: action.payload,
        error: ''
      };
    case FETCH_BRANDS_FAILURE:
      return {
        ...state,
        fetching: false,
        brands: [],
        error: action.payload
      };
    case FETCH_MODELS_PENDING:
      return {
        ...state,
        fetching: true
      };
    case FETCH_MODELS_SUCCESS:
      return {
        ...state,
        fetching: false,
        models: action.payload,
        error: ''
      };
    case FETCH_MODELS_FAILURE:
      return {
        ...state,
        fetching: false,
        models: [],
        error: action.payload
      };
    case FETCH_YEARS_PENDING:
      return {
        ...state,
        fetching: true
      };
    case FETCH_YEARS_SUCCESS:
      return {
        ...state,
        fetching: false,
        years: action.payload,
        error: ''
      };
    case FETCH_YEARS_FAILURE:
      return {
        ...state,
        fetching: false,
        years: [],
        error: action.payload
      };
    case FETCH_VERSIONS_PENDING:
      return {
        ...state,
        fetching: true
      };
    case FETCH_VERSIONS_SUCCESS:
      return {
        ...state,
        fetching: false,
        versions: action.payload,
        error: ''
      };
    case FETCH_VERSIONS_FAILURE:
      return {
        ...state,
        fetching: false,
        versions: [],
        error: action.payload
      };
    default:
      return state;
  }
}
